<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder"
    @click.self="closeModal">
    <div class="spl-modal spl-upload-modal ">
      <div class="spl-modal__label">
        Upload a File
      </div>
      <form-label>Description</form-label>
      <form-input
        v-model="description"
        :invalid="$v.description.$error"
        data-cy="spl-file-upload-modal__description"
        @blur="$v.description.$touch()" />
      <span v-if="$v.description.$error" class="error">Description is required.</span>

      <div>
        <form-label>File</form-label>
        <input
          id="uploadFile"
          ref="uploadFile"
          data-cy="spl-file-upload-modal__file"
          type="file"
          size="50"
          @change="fileUploadChanged">
      </div>
      <br>
      <span v-if="!$v.fileName.required" class="error">You need to select a file.</span>
      <span v-if="!$v.fileName.fileFormatCorrect" class="error">You only can upload a files of the following types: {{ fileTypes }}</span>
      <div class="spl-modal__close" @click="closeModal" />
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            data-cy="spl-file-upload-modal__cancel"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            :disabled="$v.$invalid"
            data-cy="spl-file-upload-modal__save"
            @onClick="submitModal">
            Save
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import webApi from '@/webApi'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { required } from 'vuelidate/lib/validators'
import { clone, map, replace } from 'lodash'
const extensions = ['.xls', '.xlsx', '.csv', '.pdf', '.doc', '.docx', '.txt', '.jpg', '.jpeg']

const checkFileFormat = (value) => {
  if (!value) {
    return true
  }
  for (let i = 0; i < extensions.length; i++) {
    const extension = extensions[i]
    if (value.toLowerCase().trim().indexOf(extension.toLowerCase().trim()) > -1) {
      return true
    }
  }
  return false
}

export default {
  mixins: [Helpers],
  data () {
    return {
      isVisible: false,
      parcelIDs: [],
      description: '',
      fileName: null,
      constants,
      extensions
    }
  },
  validations: {
    description: {
      required
    },
    fileName: {
      required,
      fileFormatCorrect: checkFileFormat
    }
  },
  computed: {
    fileTypes () {
      return map(clone(extensions), (value) => replace(value, '.', '')).join(', ')
    }
  },
  mounted () {
    // Modal was opened
    window.bus.$on('openFileUploadModal', this.handleOpenFileUploadModal)
  },
  beforeDestroy () {
    window.bus.$off('openFileUploadModal', this.handleOpenFileUploadModal)
  },
  methods: {
    handleOpenFileUploadModal (parcelIDs) {
      this.parcelIDs = parcelIDs
      this.isVisible = true
    },
    fileUploadChanged () {
      if (this.$refs.uploadFile && this.$refs.uploadFile.files) {
        this.fileName = this.$refs.uploadFile.files[0].name
      } else {
        this.fileName = null
      }
      this.$v.fileName.$touch()
    },
    submitModal () {
      var fileToUpload = this.$refs.uploadFile.files[0]
      var formData = new FormData()
      formData.append('file', fileToUpload)
      formData.append('Parcel_IDs', this.parcelIDs)
      formData.append('Document_Description', this.description)
      webApi.document.upload_Document(formData)
        .then((response) => {
          this.isVisible = false
          this.parcelIDs = []
          this.description = ''
          this.$refs.uploadFile.value = ''
          this.$toast('Upload Successfull.', constants.defaultToastOptions())
          this.$emit('fileUploaded')
        }).catch((response) => {
          window.bus.$emit('openErrorModal', 'Error uploading file: ' + response.data.ExceptionMessage)
        })
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
.spl-upload-modal {
  & .error {
    margin-top: -12px;
    margin-bottom: 8px;
  }
}
</style>
